__turbopack_context__.v({
  "button": "add-to-cart-module__g9OuHq__button",
  "form": "add-to-cart-module__g9OuHq__form",
});
